/**
 * @module isBrowserLike
 * @requires glob
 * @since 2.3.1
 */

import { glob } from '../../glob';

/**
 * Test whether the current environment is a browser-like environment or not.
 * @return {Boolean}
 */
export const isBrowserLike = () => glob.document && typeof glob.document.createElement === 'function';
